export const SET_UNIT_TO_DISPLAY = 'SET_UNIT_TO_DISPLAY';

export const setUnitToDisplay = (unitToDisplay: string) => ({
  type: SET_UNIT_TO_DISPLAY,
  data: unitToDisplay,
});
